import defineActionTypes from 'utils/defineActionTypes';

// Define action types
export default defineActionTypes('modal', ['SHOW_MODAL', 'HIDE_MODAL']);
